/**
 * MCP settings section.
 *
 * Gated by the `mcp_oauth` feature flag. Wraps the existing McpSettingsPage
 * component as a self-contained section in the settings sidebar layout.
 */

import { useFeatureFlag } from '@/hooks/useFeatureFlag';
import { useViewHealthMarker } from '@/lib/view-health';

import McpSettingsPage from '../McpSettingsPage';

export function McpSection() {
  const isMcpEnabled = useFeatureFlag('mcp_oauth');
  useViewHealthMarker('settings-section-ready', { ready: isMcpEnabled });

  if (!isMcpEnabled) {
    return null;
  }

  return (
    <div className='space-y-8'>
      <div>
        <h2 className='text-lg font-semibold text-fg-primary'>MCP</h2>
        <p className='text-sm text-fg-tertiary mt-0.5'>
          Connect MCP-compatible clients to your workspace.
        </p>
      </div>
      <div>
        <McpSettingsPage />
      </div>
    </div>
  );
}
